<template lang="pug">
v-app
  v-navigation-drawer(app expand-on-hover permanent dark ref="nav" mini-variant-width="80" :width="280" color="#959595" @transitionend="updateState")
    template(v-slot:prepend)
      v-layout.logo(column align-center pt-7 pb-2 space-between)
        img(src="/logo@40.png" width="40" height="40")
        app-appear-animation
          .mt-1.logo__text(v-if="!mini") судебный портал
      
    .drawer.py-0
      drawer-item(v-for="(el, index) in menuItems" :key="index" :item="el" :mini="mini" :id="index")
      v-expansion-panels.caption(v-if="isAdmin")
        v-expansion-panel
          v-expansion-panel-header(expand-icon="arrow_drop_down" color="white") 
            template(v-slot:default="{ open }")
              v-icon(color="white") info
              app-appear-animation
                span(v-if="!mini") Версионность
          v-expansion-panel-content
            .px-0(v-if="gas") {{ gas.serviceName }} {{ gas.version }} {{ gas.time }}
            .px-0(v-if="sync") {{ sync.serviceName }} {{ sync.version }} {{ sync.time }}
            .px-0(v-if="web") {{ web.serviceName }} {{ web.version }} {{ web.time }}
            .px-0(v-if="front") {{ front.serviceName }} {{ front.version }} {{ front.time }}

  v-main
    router-view
  
</template>

<script>
import { DrawerItems as items } from './DrawerItems'
import { $_user_role as Role } from '@/common/UserUtils'
import DrawerItem from './DrawerItem'
import { mapGetters, mapMutations } from 'vuex'
import { versionService } from '@/_services'

export default {
  components: {
    [DrawerItem.name]: DrawerItem
  },

  data () {
    return {
      mini: true,
      gas: null,
      sync: null,
      web: null,
      front: null
    }
  },

  created () {
    this.getUsername()
    this.versions()
  },

  computed: {
    ...mapGetters('specialist', ['specialistType', 'SPECIALIST_FULLNAME']),
    ...mapGetters('judge', ['JUDGE_FULLNAME']),
    ...mapGetters('me', ['hasRole']),
    
    menuItems () {
      if (window.settings.limitMenu && window.settings.limitMenu.available==true) 
        return items.filter(el => {
          if ( this.hasRole(el.requiredRoles) && (el.limitMenuKey && el.limitMenuKey == window.settings.limitMenu.key || el.noLimitMenuItem == true) ) {
            if (el.requiredRoles.includes(Role.specialist) && this.specialistType) 
               return el.specialistType == this.specialistType.value 
            return true
          }
          return false
        })
      else
        return items.filter(el => {
          if (this.hasRole(el.requiredRoles) && !el.limitMenuKey) {
            if (el.requiredRoles.includes(Role.specialist) && this.specialistType) 
               return el.specialistType == this.specialistType.value 
            return true
          }
          return false
        })
    },

    isAdmin () {
      return this.hasRole([Role.admin])
    },

  },

  methods: {
    ...mapMutations('me', ['setFullname']),

    versions () {
      versionService.gasV().then(data => this.gas = data)
      versionService.syncV().then(data => this.sync = data)
      versionService.webV().then(data => this.web = data)
      versionService.frontV().then(([version, time]) => this.front = { serviceName: "front", version: "v-" + version, time: "t-" + time })
    },

    updateState () {
      this.mini = !this.$refs.nav.isMouseover
    },

    getUsername () {
      let path = this.hasRole([Role.judge]) ? 'judge/GET_JUDGE' : this.hasRole([Role.specialist]) ? 'specialist/LOAD_AUTH_SPEC' : 'users/GET_AUTH_USER'
      this.$store.dispatch(path).then(() => {
      
        let fullname = localStorage.getItem('fio') != null && localStorage.getItem('fio') != 'null' ? localStorage.getItem('fio').replace(/"/g, "") : 
          this.hasRole([Role.judge]) ? this.JUDGE_FULLNAME : 
          this.hasRole([Role.specialist]) ? this.SPECIALIST_FULLNAME : 
          `Пользователь: ${localStorage.getItem('LoginName')}`
        this.setFullname(fullname)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
$logo-height: 100px;

.logo {
  height: $logo-height;
  border-bottom: 1px solid $app-logo-divider-color;
  
  &__text {
    font: $app-logo-text-font;
    color: $app-logo-text-color;

    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
  }
}

.drawer {
  height: calc(100vh - #{$logo-height});
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */

  &::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
  }
}
.drawer--bg {
  background-color: #959595;
  &:hover {
    background: #19AFDE;
  }
}
.drawer-panel--active {
  background-color: rgba(196, 196, 196, 0.5);
}
.drawer-panel__header {
  color: white;
}
</style>
